import { render, staticRenderFns } from "./quesBankDetail.vue?vue&type=template&id=173cf534&scoped=true"
import script from "./quesBankDetail.vue?vue&type=script&lang=ts"
export * from "./quesBankDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173cf534",
  null
  
)

export default component.exports